import { FC } from 'react';
import { useFragment } from 'react-relay';
import { SxProps, Theme } from '@mui/material/styles';
import graphql from 'babel-plugin-relay/macro';

import Grid from '@mui/material/Grid';
import FlightInfo from 'components/FlightInfo';
import FlightDetailsPrice from 'components/FlightDetailsPrice';

import { FlightDetails_flight$key } from '__generated__/FlightDetails_flight.graphql';

type Props = {
  flight: FlightDetails_flight$key;
  sx?: SxProps<Theme>;
};

const FlightDetails: FC<Props> = props => {
  const flight = useFragment(
    graphql`
      fragment FlightDetails_flight on FlightType {
        ...FlightDetailsPrice_flight

        forwardSegments {
          ...FlightInfo_segments
        }

        returnSegments {
          ...FlightInfo_segments
        }
      }
    `,
    props.flight
  );

  const { children, sx } = props;

  return (
    <Grid container spacing={1} sx={sx}>
      <Grid item sm={9}>
        <FlightInfo segments={flight.forwardSegments} />
        <FlightInfo segments={flight.returnSegments} />
      </Grid>

      <Grid item sm={3}>
        <FlightDetailsPrice flight={flight}>{children}</FlightDetailsPrice>
      </Grid>
    </Grid>
  );
};

export default FlightDetails;
